// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.btn[data-v-fae2a244]{\r\n  color: white !important;\n}\n.btnSelect[data-v-fae2a244]{\r\n  background-color: #28a745;\n}\r\n", ""]);
// Exports
module.exports = exports;
